import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	Button,
	Card,
	CardBody,
	Col,
	Modal,
	ModalBody,
	ModalHeader,
	Row
} from "reactstrap";
import * as api from "services/api";
import { toast } from "react-toastify";
import { getCompanyById } from "../actions";
import ToggleSwitch from "components/ToggleSwitch";

const MonthlyReportIntegration = () => {
	const dispatch = useDispatch();

	const { item: company } = useSelector(state => state.companyDetail);
	const { token } = useSelector(state => state.login);

	const [monthlyReport, setMonthlyReport] = useState(
		!!company?.monthlyReportEnabled
	);
	const [monthlyReportProvider, setMonthlyReportProvider] = useState(
		!!company?.monthlyReportProviderEnabled
	);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [modal, setModal] = useState(false);

	useEffect(() => {
		setMonthlyReport(!!company?.monthlyReportEnabled);
		setMonthlyReportProvider(!!company?.monthlyReportProviderEnabled);
	}, [company?.monthlyReportEnabled, company?.monthlyReportProviderEnabled]);

	const toggleModal = () => setModal(prev => !prev);

	const hasChanges =
		monthlyReport !== !!company?.monthlyReportEnabled ||
		monthlyReportProvider !== !!company?.monthlyReportProviderEnabled;

	const handleSubmit = async () => {
		setIsSubmitting(true);

		const response = await api.sendPut(
			`/company/${company._id}/monthly-report-preference`,
			{
				monthlyReport,
				monthlyReportProvider
			},
			{ Authorization: "Bearer " + token }
		);

		if (!response) {
			toast.error("Erro de conexão.");
			setIsSubmitting(false);
			return;
		}

		const result = await response.json();

		if (result.isValid) {
			toggleModal();
			toast.success(
				"Preferências de relatório mensal atualizadas com sucesso!"
			);
			dispatch(
				getCompanyById(company._id, err => {
					if (err) console.log(err);
				})
			);
		} else {
			toast.error(
				result.errors?.message ||
					result.errors?.default ||
					"Houve um erro ao processar a ação."
			);
			toggleModal();
		}

		setIsSubmitting(false);
	};

	return (
		<Card>
			<CardBody>
				<Row id="monthly-report-title">
					<Col>
						<h4>
							<strong>Relatório Mensal</strong>
						</h4>
					</Col>
				</Row>

				<div className="topbar__menu-divider" />

				<Row className="mt-3">
					<Col md={6}>
						<p>
							<strong>Relatório mensal para o contratante</strong>
						</p>
						<ToggleSwitch
							id="monthly-report-hirer"
							name="monthlyReport"
							checked={monthlyReport}
							onChange={event => setMonthlyReport(event.target.checked)}
						/>
					</Col>
					<Col md={6}>
						<p>
							<strong>Relatório mensal dos prestadores</strong>
						</p>
						<ToggleSwitch
							id="monthly-report-provider"
							name="monthlyReportProvider"
							checked={monthlyReportProvider}
							onChange={event => setMonthlyReportProvider(event.target.checked)}
						/>
					</Col>
				</Row>

				<Row className="mt-3">
					<Col className="text-right">
						<Button
							color="primary"
							onClick={toggleModal}
							disabled={!hasChanges}
						>
							Salvar
						</Button>
					</Col>
				</Row>

				<Modal isOpen={modal} toggle={toggleModal}>
					<ModalHeader
						toggle={toggleModal}
						className="card__title bold-text m-0"
					>
						<strong>Confirmar alteração do Relatório Mensal</strong>
					</ModalHeader>

					<ModalBody>
						<p className="h6">
							Deseja salvar as seguintes alterações para esta empresa?
						</p>
						<ul>
							{monthlyReport !== !!company?.monthlyReportEnabled && (
								<li>
									Relatório mensal para o <strong>contratante</strong> será{" "}
									<strong>
										{monthlyReport ? "habilitado" : "desabilitado"}
									</strong>
								</li>
							)}
							{monthlyReportProvider !==
								!!company?.monthlyReportProviderEnabled && (
								<li>
									Relatório mensal dos <strong>prestadores</strong> será{" "}
									<strong>
										{monthlyReportProvider ? "habilitado" : "desabilitado"}
									</strong>
								</li>
							)}
						</ul>
						<p className="text-muted small">
							Essa ação será registrada no histórico desta empresa, com data e
							usuário responsável.
						</p>

						<div className="d-flex justify-content-between mt-3">
							<Button
								type="button"
								onClick={toggleModal}
								disabled={isSubmitting}
							>
								Cancelar
							</Button>
							<Button
								color="primary"
								onClick={handleSubmit}
								disabled={isSubmitting}
							>
								{isSubmitting ? "Aguarde..." : "Confirmar"}
							</Button>
						</div>
					</ModalBody>
				</Modal>
			</CardBody>
		</Card>
	);
};

export default MonthlyReportIntegration;
